var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "view-point-app-container",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogLoading,
              expression: "dialogLoading",
            },
          ],
          attrs: {
            top: _vm.dialogTopMargin,
            title: _vm.funcName + "維護",
            visible: _vm.dialogVisible,
            width: "50%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-card",
            { staticClass: "box-card" },
            [
              _c(
                "el-form",
                {
                  ref: "form",
                  attrs: { model: _vm.form, "label-width": _vm.formLabelWidth },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.funcName + "使用區域",
                        prop: "countryAreaList",
                        rules: [
                          {
                            required: true,
                            message: "請輸入景點區域",
                            trigger: "change",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          clearable: "",
                          props: {
                            checkStrictly: true,
                            expandTrigger: "hover",
                          },
                          placeholder: "請選擇",
                          filterable: "",
                          options: _vm.travelAttractionsMenu,
                        },
                        model: {
                          value: _vm.form.countryAreaList,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "countryAreaList", $$v)
                          },
                          expression: "form.countryAreaList",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.funcName + "名稱",
                        prop: "viewPointName",
                        rules: [
                          {
                            required: true,
                            message: "請輸入景點名稱",
                            trigger: "blur",
                          },
                        ],
                      },
                    },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.form.viewPointName,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "viewPointName", $$v)
                          },
                          expression: "form.viewPointName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.funcName + "座標" } },
                    [
                      _c(
                        "el-row",
                        [
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "北緯(lat)",
                                    prop: "lat",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸座標北緯度",
                                        trigger: "blur",
                                      },
                                      {
                                        type: "number",
                                        message: "座標緯度必須為數字",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.lat,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "lat", _vm._n($$v))
                                      },
                                      expression: "form.lat",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-col",
                            { attrs: { span: 12 } },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "東經(lng)",
                                    prop: "lng",
                                    rules: [
                                      {
                                        required: true,
                                        message: "請輸座標東經度",
                                        trigger: "blur",
                                      },
                                      {
                                        type: "number",
                                        message: "座標經度必須為數字",
                                      },
                                    ],
                                  },
                                },
                                [
                                  _c("el-input", {
                                    model: {
                                      value: _vm.form.lng,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "lng", _vm._n($$v))
                                      },
                                      expression: "form.lng",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.saveData } },
                [_vm._v("確 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { padding: "20px", "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: _vm.funcName + "使用區域" } },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      clearable: "",
                      props: { checkStrictly: true, expandTrigger: "hover" },
                      placeholder: "請選擇",
                      filterable: "",
                      options: _vm.travelAttractionsMenu,
                    },
                    model: {
                      value: _vm.listQuery.countryAreaList,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "countryAreaList", $$v)
                      },
                      expression: "listQuery.countryAreaList",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "查詢" } },
                [
                  _c("el-input", {
                    attrs: { placeholder: "輸入景點名稱" },
                    nativeOn: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.getList($event)
                      },
                    },
                    model: {
                      value: _vm.listQuery.qry,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "qry", $$v)
                      },
                      expression: "listQuery.qry",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.getList } },
                    [_vm._v("查詢")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "success" }, on: { click: _vm.addData } },
                    [_vm._v("新增")]
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c("el-button", {
                    staticStyle: { cursor: "pointer" },
                    attrs: {
                      loading: _vm.listLoading,
                      type: "success",
                      icon: "el-icon-refresh-left",
                      circle: "",
                    },
                    on: {
                      click: function ($event) {
                        return _vm.refresh()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
              },
            },
            [
              _c("el-table-column", {
                attrs: { align: "center", label: "項次", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "區域", width: "210" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-cascader", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: true,
                            clearable: "",
                            props: {
                              checkStrictly: true,
                              expandTrigger: "hover",
                            },
                            placeholder: "請選擇",
                            filterable: "",
                            options: _vm.travelAttractionsMenu,
                          },
                          model: {
                            value: scope.row.countryAreaList,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "countryAreaList", $$v)
                            },
                            expression: "scope.row.countryAreaList",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "景點名稱", width: "300" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.viewPointName))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: _vm.funcName + "座標北緯度",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.lat))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: _vm.funcName + "座標東經度",
                  width: "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.lng))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "編輯", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.editData(scope.row)
                              },
                            },
                          },
                          [_vm._v("編輯")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0" },
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }